import type { VoidFunctionComponent } from 'react';

import Locator from '../../../../../shared/Locator';
import BulkSelectionBanner from '../../../generic/BulkSelectionBanner';
import type { SnippetsResponse } from '../../../../../shared/snippets';
import type { SnippetSelectionState } from '../hooks/useSnippetSelectionState';

type Props = {
  selectionState: SnippetSelectionState;
  snippets: SnippetsResponse;
  userRevisionLocator: string;
};

/**
 * Component which displays the bulk selection banner for snippets.
 * This gets shown when the user has selected all snippets on the current page
 * or the "select all" option in the header.
 */
const SnippetsBulkSelectionBanner: VoidFunctionComponent<Props> = ({
  selectionState,
  snippets,
  userRevisionLocator,
}) => {
  const { package: pkgName } = Locator.parse(userRevisionLocator);
  return (
    <BulkSelectionBanner
      itemsNoun="snippet"
      pageSize={snippets.results.length}
      totalItemsCount={snippets.totalCount}
      areAllItemsSelected={selectionState.selection === 'all'}
      sectionName={pkgName || 'snippets'}
      onSelectAll={selectionState.selectAll}
      onClearSelection={selectionState.clearSelection}
    />
  );
};

export default SnippetsBulkSelectionBanner;
